import React from "react";

const Steps = (props) => (
  <svg
    width="30px"
    height="30px"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      d="m27.227 20.917-6.21-1.664c.204-2.22 0-4.745-1.205-7.11-.18-6.195 1.867-11.962 6.835-10.631 5.468 1.466 4.865 13.9.58 19.404zm-.409 2.619c-.343 11.973-12.512 6.497-6.318-1.693zm-21.76-2.618 6.21-1.664c-.204-2.22 0-4.745 1.205-7.11.18-6.195-1.867-11.962-6.835-10.631C.17 2.978.773 15.412 5.058 20.917zm.41 2.619c.343 11.974 12.512 6.497 6.318-1.693z"
    />
  </svg>
);

export default Steps;
